type DropDownFilter1Options = {
  rootSelector?: string;
  btnSelector?: string;
  boxSelector?: string;
  linkSelector?: string;
  textSelector?: string;
  activeClass?: string;
  disabledClass?: string;
};

export function initDropDownFilter1({
  rootSelector = '.drop-down-filter-1',
  btnSelector = '.drop-down-filter-1__btn',
  boxSelector = '.drop-down-filter-1__box',
  linkSelector = '.drop-down-filter-1__link',
  textSelector = '.text',
  activeClass = 'active',
  disabledClass = 'disabled'
}: DropDownFilter1Options = {}): void {
  const dropdowns = document.querySelectorAll<HTMLElement>(rootSelector);
  if (!dropdowns.length) return;

  dropdowns.forEach(container => {
    const button = container.querySelector<HTMLElement>(btnSelector);
    const box = container.querySelector<HTMLElement>(boxSelector);
    const textSpan = container.querySelector<HTMLElement>(textSelector);
    const links = box?.querySelectorAll<HTMLElement>(linkSelector);
    const closeBtn = box?.querySelector<HTMLElement>('.js-close');

    if (!button || !box || !textSpan || !links?.length) return;

    const closeDropdown = (): void => {
      button.classList.remove(activeClass);
      box.classList.remove(activeClass);
      document.removeEventListener('click', handleOutsideClick);
      document.removeEventListener('keydown', handleEscape);
    };

    const openDropdown = (): void => {
      button.classList.add(activeClass);
      box.classList.add(activeClass);
      document.addEventListener('click', handleOutsideClick);
      document.addEventListener('keydown', handleEscape);
      updateLinksState();
    };

    const handleOutsideClick = (e: MouseEvent): void => {
      if (!container.contains(e.target as Node)) {
        closeDropdown();
      }
    };

    const handleEscape = (e: KeyboardEvent): void => {
      if (e.key === 'Escape') {
        closeDropdown();
      }
    };

    const updateLinksState = (): void => {
      const currentText = textSpan.textContent?.trim() || '';

      links.forEach(link => {
        const linkText = link.textContent?.trim() || '';
        link.classList.toggle(
          disabledClass,
          linkText === currentText
        );
      });
    };

    button.addEventListener('click', (e: MouseEvent) => {
      e.preventDefault();

      button.classList.contains(activeClass)
        ? closeDropdown()
        : openDropdown();
    });

    links.forEach(link => {
      link.addEventListener('click', (e: MouseEvent) => {
        e.preventDefault();

        textSpan.textContent = link.textContent?.trim() || '';
        closeDropdown();
        updateLinksState();
      });
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', (e: MouseEvent) => {
        e.preventDefault();
        closeDropdown();
      });
    }

    updateLinksState();
  });
}